import axios from "axios";
import _ from "lodash";
import toast from "react-hot-toast";
import {clearSessionData} from "./AppHelper.jsx";

const $http = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
});

$http.interceptors.request.use(async function (config) {
	try {
		const token = localStorage.getItem('token');
		if (!_.isEmpty(token)) {
			config.headers.Authorization = `Bearer ${token}`;
		}
	} catch (err) {
		/* empty */
	}
	return config;
});

$http.interceptors.response.use(function (response) {
	return response;
}, async function (error) {
	if (_.includes([403, 401, 423], error?.status)) {
		clearSessionData();
		toast.error("Please login to access", {id: 'logged_out'});
		window.location.href = '/login';
	}
	return Promise.reject(error);
});

export default $http;
